import { render, staticRenderFns } from "./ProductViewerAside.vue?vue&type=template&id=4df45005&scoped=true&"
import script from "./ProductViewerAside.vue?vue&type=script&lang=js&"
export * from "./ProductViewerAside.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewerAside.vue?vue&type=style&index=0&id=4df45005&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df45005",
  null
  
)

export default component.exports